/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Rails from "rails-ujs";
import {
  GOVUKInitAll,
  HMRCInitAll,
  ClearCookies,
} from "dvla-external-frontend";

Rails.start();

GOVUKInitAll();
HMRCInitAll();
ClearCookies.init();

// Import main stylesheet
import "./application.scss";

// ensure the stylesheets are included in the compiled pack
require.context("./stylesheets/", true, /^\.\/[^_].*\.(css|scss|sass)$/i);

// ensure images are included in the compiled pack
require.context("./images", true);

// ensure dvla-external-frontend/dist/media are included in the compiled pack
require.context("dvla-external-frontend/dist/media", true);
